import { createTheme } from '@mui/material/styles';
import { baseTheme } from './base';

const theme = createTheme(baseTheme, {
  palette: {
    error: {
      main: '#E04A57',
      dark: '#C93340',
      light: '#FA6976',
      contrastText: '#FFF3F3',
    },
    warning: {
      main: '#FB6434',
      dark: '#FFC11B',
      light: '#FF835C',
      contrastText: '#5C003C',
    },
    info: {
      main: '#2375C0',
      dark: '#1A64A8',
      light: '#3291E9',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#2CA670',
      dark: '#2D674E',
      light: '#96EAC4',
      contrastText: '#CFFFED',
    },
    grayScale: {
      50: '#FBFBFB',
      100: '#EDEBEB',
      200: '#CCC8C8',
      300: '#9D9D9D',
      400: '#7F7F7F',
      500: '#4B4D58',
      600: '#546E7A',
      700: '#383737',
      800: '#252525',
      900: '#12162A'
    },
  },
  typography: {
    fontFamily: 'Noto Sans sans-serif',
    h1: {
      fontFamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '28px',
      letterSpacing: 'normal',
      lineHeight: 'normal',
      color: "#D91E49"
    },
    h2: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '26px',
      letterSpacing: 'normal',
      lineHeight: 'normal',
      color: "#D91E49"
    },
    h3: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '24px',
      letterSpacing: 'normal',
      lineHeight: 'normal',
      color: "#D91E49"
    },
    h4: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '20px',
      letterSpacing: 'normal',
      lineHeight: 'normal',
      color: "#D91E49"
    },
    h5: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '18px',
      letterSpacing: 'normal',
      lineHeight: 'normal',
      color: "#D91E49"
    },
    h6: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '16px',
      letterSpacing: '1px',
      lineHeight: 'normal',
      color: "#D91E49"
    },
    montseratH1: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 700,
      fontSize: '40px',
      letterSpacing: "0.5%",
      color: "#1C1B1A"
    },
    montseratBodyRegular: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 300,
      fontSize: '1rem',
      letterSpacing: "-1.5%",
      color: "#000000"
    },
    montseratBodyRegular2: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 400,
      fontSize: '14px',
      letterSpacing: "0.25px",
      lineHeight: "24px",
      color: "#000000"
    },
    montseratBodyMedium: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 500,
      fontSize: '20px',
      letterSpacing: "1.5%",
      lineHeight: "16px",
      color: "#000000"
    },
    montseratBodySemiBold: {
      fontFamily: "'Montserrat', sans-serif",
      fontWeight: 600,
      fontSize: '11px',
      letterSpacing: "0.25px",
      color: "#000000"
    },
    body1Regular: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '21.79px',
      color: "#1E1E23"
    },
    body1Medium: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 500,
      fontSize: '16px',
      color: "#484A4C"
    },
    body1SemiBold: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '21.79px',
      color: "#484A4C"
    },
    body2: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '21.79px',
      color: "#484A4C"
    },
    body3Regular: {
      fontfamily: 'Noto Sans sans-serif',
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '27.24px',
      color: "#484A4C"
    },
    poppinsH1: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: '40px',
      lineHeight: "100%",
      color: "#1C1B1A"
    },
    poppinsBodyLight: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 300,
      fontSize: '16px',
      lineHeight: "24px",
      letterSpacing: "0%",
      color: "#000000"
    },
    poppinsBodyRegular: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: "24px",
      color: "#000000"
    },
    poppinsBodyMedium: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: '16px',
      color: "#000000"
    },
    poppinsBodySemiBold: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 600,
      fontSize: '11px',
      lineHeight: "125%",
      color: "#000000"
    },
    poppinsBodyBold: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: "24px",
      color: "#000000"
    },
    opticianBodyRegular: {
      fontFamily: 'Optician Sans, sans-serif',
      fontWeight: 400,
      fontSize: '28px',
      lineHeight: "24px",
      color: "#000000"
    },
    components: {
      inputLabel: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        fontSize: '1rem',
        color: '#1E1E23',
        lineHeight: '21.79px'
      },
      inputText: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '1.063rem',
        letterSpacing: '0.15px',
        color: '#1E1E23',
      },
      helperText: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '0.875rem',
        letterSpacing: '0.4px',
        color: '#686A6C',
      },
      menuLabel: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '1.125rem',
        color: '#1E1E23',
        lineHeight: '21.79px'
      },
      captionsText: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '0.75rem',
        color: '#686A6C',
        lineHeight: '20px'
      },
      montseratButtonContainedLabel: {
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 700,
        fontSize: '13.96px',
        letterSpacing: "-1.5%",
        color: "#fff"
      },
      montseratButtonOutlinedLabel: {
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 700,
        fontSize: '13.96px',
        letterSpacing: "-1.5%",
        color: "inherit"
      },
      sectionTitle: {
        fontFamily: 'Optician Sans, sans-serif',
        fontWeight: 400,
        fontSize: '32px',
        letterSpacing: "0%",
        lineHeight: "100%",
        color: "#1E1E22"
      },
      sectionDescription: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 300,
        fontSize: '18px',
        letterSpacing: "-1.5%",
        lineHeight: "24px",
        color: "#000"
      },
      breadcrump: {
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 400,
        fontSize: '16px',
        color: "#0D1C2A"
      }
    }
  },
  components: {
    shadowCard: {
      boxShadow: '0px 1px 5px 0px rgba(37, 37, 37, 0.12), 0px 2px 2px 0px rgba(37, 37, 37, 0.14), 0px 3px 1px -2px rgba(37, 37, 37, 0.20)',
    }
  },
  button: {
    contained: {
      primary: {
        background: '#4B69F1',
        color: '#FFFFFF',
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 600,
        fontSize: '1rem',
        lineHeight: '26px',
        borderRadius: "8px",
        height: "42px",
      }
    }
  }
}) as any;

export { theme, theme as godzilla };
